export default {
  state: {
    appState: {
      serverConnected: true,

      // для случаев когда например пользователь открывает url а он не авторизован,
      // значит сначала пользователя надо отправить на /signin а при успешной авторизации вернуть на изначальный url
      // или случай например с потеряй связи с сервером - надо перевести на страницу /serverIsNotAvailable
      lastWorkingRoute: ''
    }
  },
  getters: {
    appState: state => state.appState
  },
  mutations: {
    appStateServerConnectedSet (state, value) {
      state.appState.serverConnected = value
    },
    appStateLastWorkingRouteSet (state, value) {
      // если lastWorkingRoute уже установлен то не меняем, чтобы предотвратить ситуацию что пользователь шел по /profile,
      // он не залогинен и перевели /signin, потерялась связь с сервером и перевели на /serverisnotavailable
      // Стирать значение надо через appStateLastWorkingRouteGetAndUnset
      if ((state.appState.lastWorkingRoute === '') || (value === '' /* lets do unset */)) {
        state.appState.lastWorkingRoute = value
      }
    }
  },
  actions: {
    appStateLastWorkingRouteGetAndUnset ({commit, getters}) {
      let result = getters.appState.lastWorkingRoute
      commit('appStateLastWorkingRouteSet', '')
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/storeAppState.js